export default __webpack_public_path__ + "static/media/knowledge-base-def.db89fd0d.svg";